module.exports = __webpack_public_path__ + "img/mD-badge2-dark.b1bb41f6.png";